export const getCustomerSatisfactionSurvey = state => state.customerSatisfactionSurvey;
